
const projects = [
    {
      id: 1,
      title: "Car Rental Platform",
      description: "A full-stack application for booking and managing car rentals",
      tags: ["React", "Node.js", "MongoDB", "Google Maps API", "express"],
      image: "https://res.cloudinary.com/dtfrsnzzt/image/upload/v1755029108/Car_Rental_App_nlx6hu.png",
      link: "#",
      github: "#",
      category: "web"
    },
    {
      id: 2,
      title: "Home Service Platform",
      description: "A frontend application for booking home services",
      tags: ["React", "Tailwind CSS", "EmailJS", "Google Maps API"],
      image: "https://res.cloudinary.com/dtfrsnzzt/image/upload/v1755029585/Home_Service_pkjeua.png",
      link: "#",
      github: "#",
      category: "web"
    },
    {
      id: 3,
      title: "Event Management System",
      description: "A web based for managing events and ticketing",
      tags: ["React", "MongoDb", "OAuth2.0", "VPS" , "Express" , "Node.js" , "Socket.io", "typescript"],
      // image:demo ,
      link: "#",
      github: "#",
      category: "mobile"
    },
    {
      id: 4,
      title: "Islamic Essentials",
      description: "Religious app providing prayer times, Qibla direction, and Islamic calendar",
      tags: ["React","Tailwind CSS","API" ],
      // image: demo,
      link: "https://islamicalendar.in/",
      github: "#",
      category: "web"
    },
    // {
    //   id: 5,
    //   title: "SaaS Analytics Platform",
    //   description: "Business intelligence dashboard for SMBs",
    //   tags: ["Vue.js", "Python", "PostgreSQL", "Docker"],
    //   image: demo,
    //   link: "#",
    //   github: "#",
    //   category: "web"
    // },
    // {
    //   id: 6,
    //   title: "Fitness Tracking App",
    //   description: "AI-powered workout and nutrition coach",
    //   tags: ["Flutter", "TensorFlow", "Firebase", "HealthKit"],
    //   image: demo,
    //   link: "#",
    //   github: "#",
    //   category: "mobile"
    // }
  ];


  export default projects;